const buttonText = {
    enter: 'Entrar',
    next: 'Avançar',
    back: 'Voltar',
    ok: 'Ok',
    understood: 'Entendi',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    register: 'Cadastrar',
    newAccount: 'Criar nova conta',
    recoverAccount: 'Recuperar conta',
    tryAgain: 'Tentar novamente'
};

export default buttonText;